var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90566 2.64243C8.20526 2.19303 8.70964 1.9231 9.24974 1.9231H10.7515C11.2916 1.9231 11.7959 2.19303 12.0955 2.64243L12.8275 3.7404H15.8564C16.1909 3.7404 16.4621 4.01162 16.4621 4.34617C16.4621 4.68073 16.1909 4.95194 15.8564 4.95194H4.14483C3.81027 4.95194 3.53906 4.68073 3.53906 4.34617C3.53906 4.01162 3.81027 3.7404 4.14483 3.7404H7.17368L7.90566 2.64243ZM12.4237 18.0769H7.57752C5.79322 18.0769 4.34675 16.6305 4.34675 14.8462V5.96156H15.6544V14.8462C15.6544 16.6305 14.208 18.0769 12.4237 18.0769ZM8.38522 8.58656C8.71977 8.58656 8.99098 8.85777 8.99098 9.19233V14.8462C8.99099 15.1807 8.71977 15.4519 8.38522 15.4519C8.05066 15.4519 7.77945 15.1807 7.77945 14.8462L7.77945 9.19233C7.77945 8.85777 8.05066 8.58656 8.38522 8.58656ZM11.616 8.58656C11.9505 8.58656 12.2218 8.85777 12.2218 9.19233V14.8462C12.2218 15.1807 11.9505 15.4519 11.616 15.4519C11.2814 15.4519 11.0102 15.1807 11.0102 14.8462V9.19233C11.0102 8.85777 11.2814 8.58656 11.616 8.58656Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1be64942284962b464cf7f2b43adb921.svg";
export { ForwardRef as ReactComponent };